import { Reveal, RevealGroup, revealItem } from "@/components/Reveal";
import { motion } from "framer-motion";

export default function Bio() {
  const stats = [
    { label: "Years Touring", value: "08" },
    { label: "Cities Played", value: "47" },
    { label: "Released Mixes", value: "32" },
    { label: "BPM Range", value: "120–140" },
  ];
  return (
    <section
      id="bio"
      data-testid="bio-section"
      className="relative py-24 sm:py-32 border-b border-white/10"
    >
      <div className="max-w-7xl mx-auto px-6 sm:px-8 grid grid-cols-1 lg:grid-cols-12 gap-12">
        <Reveal className="lg:col-span-4">
          <div className="flex items-center gap-3 mb-6">
            <span className="font-mono text-xs tracking-[0.3em] uppercase text-[#FF2A2A]">
              [ 01 / Profile ]
            </span>
          </div>
          <h2 className="font-heading font-bold uppercase tracking-tight text-3xl sm:text-4xl lg:text-5xl leading-[0.95]">
            Static is a<br />
            <span className="text-[#FF2A2A]">language.</span>
            <br />I speak it.
          </h2>
        </Reveal>

        <RevealGroup className="lg:col-span-7 lg:col-start-6 space-y-6">
          <motion.p variants={revealItem} className="text-lg leading-relaxed text-[#C4C4C4]">
            Disko Bhute is the alias of a producer-DJ moving between Berlin's reinforced
            basements and Bangalore's late-night courtyards. The work lives in dark minimal
            techno and psy tech — hypnotic, low-slung, designed to bend a room past
            midnight and keep it there.
          </motion.p>
          <motion.p variants={revealItem} className="text-base leading-relaxed text-[#8A8A8A]">
            Recent sets at Berghain, Sub Club, and Magnetic Fields. Releases on
            Strawberry Tongue, Eyes Down, and self-pressed cassette runs. One sound,
            two tempos — the midnight sound.
          </motion.p>

          {/* Stats grid */}
          <motion.div variants={revealItem} className="grid grid-cols-2 sm:grid-cols-4 gap-px bg-white/10 mt-12 border border-white/10">
            {stats.map((s) => (
              <div
                key={s.label}
                data-testid={`stat-${s.label.toLowerCase().replace(/\s+/g, "-")}`}
                className="bg-[#0A0A0A] p-5 sm:p-6 hover:bg-[#121212] transition-colors"
              >
                <div className="font-heading font-black text-3xl sm:text-4xl tracking-tighter">
                  {s.value}
                </div>
                <div className="font-mono text-[10px] sm:text-xs tracking-[0.2em] uppercase text-[#8A8A8A] mt-2">
                  {s.label}
                </div>
              </div>
            ))}
          </motion.div>
        </RevealGroup>
      </div>
    </section>
  );
}
